/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";
import FleetVehicleSelect from "../VehicleManagement/FleetVehicleSelect";

const TAG_OPTIONS = [
  "Fuel Issue", "Late Arrival", "Vehicle Damage", "Route Deviation",
  "Misconduct", "Breakdown", "Customer Complaint", "Other"
];

export default function EmployeeEscalations() {
  const [escalations, setEscalations] = useState([]);
  const [loading, setLoading]         = useState(false);
  const [vFilter, setVFilter]         = useState("");
  const [sFilter, setSFilter]         = useState("");
  const [showForm, setShowForm]       = useState(false);

  // Add form state
  const [form, setForm] = useState({
    vehicle: "", date: new Date().toISOString().split("T")[0],
    desc: "", tags: []
  });
  const [formErr, setFormErr] = useState("");
  const [formOk, setFormOk]  = useState(false);

  const fetchEscalations = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/escalations`);
      setEscalations(res.data?.data || res.data || []);
    } catch (e) {
      console.error(e);
      alert("Error: " + (e?.response?.data?.message || e.message || "Operation failed."));
    }
    setLoading(false);
  };

  useEffect(() => { fetchEscalations(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await axios.patch(`${API_BASE_URL}/api/escalations/${id}`, { status });
      fetchEscalations();
    } catch (e) { alert("Update failed"); }
  };

  const deleteEsc = async (id) => {
    if (!window.confirm("Delete this escalation?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/api/escalations/${id}`);
      fetchEscalations();
    } catch (e) { alert("Delete failed"); }
  };

  const toggleTag = (tag) => {
    setForm(f => ({
      ...f,
      tags: f.tags.includes(tag) ? f.tags.filter(t => t !== tag) : [...f.tags, tag]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.vehicle.trim() || !form.desc.trim()) { setFormErr("Vehicle and description are required."); return; }
    setFormErr("");
    try {
      await axios.post(`${API_BASE_URL}/api/escalations`, form);
      setForm({ vehicle: "", date: new Date().toISOString().split("T")[0], desc: "", tags: [] });
      setFormOk(true); setTimeout(() => setFormOk(false), 3000);
      fetchEscalations();
    } catch (err) { setFormErr(err.response?.data?.message || "Submit failed"); }
  };

  // Unique vehicles for filter dropdown
  const vehicles = [...new Set(escalations.map(e => e.vehicle))].sort();

  const filtered = escalations.filter(e => {
    const matchV = !vFilter || e.vehicle === vFilter;
    const matchS = !sFilter || e.status  === sFilter;
    return matchV && matchS;
  });

  const openCount = escalations.filter(e => e.status === "open").length;

  const S = {
    container:  { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    body:       { padding: "20px" },
    toolbar:    { display: "flex", gap: 10, alignItems: "center", marginBottom: 16, flexWrap: "wrap" },
    input:      { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    select:     { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, background: "#fff" },
    btnYellow:  { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:   { background: "#000", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    card:       { border: "1px solid #ddd", borderRadius: 8, padding: "14px 18px", marginBottom: 10, background: "#fff" },
    cardOpen:   { borderColor: "rgba(239,68,68,0.4)", background: "#fff" },
    cardResolved:{ borderColor: "rgba(34,197,94,0.4)", background: "#f9fffe" },
    formCard:   { background: "#fff", border: "1px solid #000", borderRadius: 8, padding: "16px 18px", marginBottom: 20, maxWidth: 680 },
    label:      { fontSize: 12, fontWeight: "bold", marginBottom: 4, display: "block" },
    textarea:   { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, width: "100%", boxSizing: "border-box", minHeight: 70, resize: "vertical" },
    tagWrap:    { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 },
    tag:        { padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer", border: "1px solid #ccc", background: "#fff", fontFamily: "Arial, sans-serif" },
    tagOn:      { background: "#FFC107", border: "1px solid #e6ac00", color: "#000", fontWeight: "bold" },
    success:    { background: "#e6f9ee", border: "1px solid #27ae60", color: "#27ae60", padding: "10px", borderRadius: 6, marginTop: 10, fontSize: 13 },
    errBox:     { background: "#fde8e8", border: "1px solid #c0392b", color: "#c0392b", padding: "10px", borderRadius: 6, marginTop: 10, fontSize: 13 },
    grid2:      { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 },
    btnSmall:   (color) => ({ background: color === "green" ? "#e6f9ee" : color === "red" ? "#fde8e8" : "#f5f5f5", border: `1px solid ${color === "green" ? "#27ae60" : color === "red" ? "#c0392b" : "#ccc"}`, color: color === "green" ? "#27ae60" : color === "red" ? "#c0392b" : "#555", padding: "4px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: "bold" }),
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">
        🚨 Escalations
        {openCount > 0 && (
          <span style={{ marginLeft: 10, background: "#f87171", color: "#fff", fontSize: 12, fontWeight: "bold", padding: "2px 10px", borderRadius: 12 }}>
            {openCount} Open
          </span>
        )}
      </h2>

      <div style={S.body}>
        {/* Toolbar */}
        <div style={S.toolbar}>
          <select style={S.select} value={vFilter} onChange={e => setVFilter(e.target.value)}>
            <option value="">All Vehicles</option>
            {vehicles.map(v => <option key={v}>{v}</option>)}
          </select>
          <select style={S.select} value={sFilter} onChange={e => setSFilter(e.target.value)}>
            <option value="">All Status</option>
            <option value="open">🔴 Open</option>
            <option value="resolved">🟢 Resolved</option>
          </select>
          <button style={S.btnBlack} onClick={() => setShowForm(!showForm)}>
            {showForm ? "✕ Cancel" : "➕ Add Escalation"}
          </button>
        </div>

        {/* Add Escalation Form */}
        {showForm && (
          <div style={S.formCard}>
            <div style={{ fontWeight: "bold", fontSize: 14, marginBottom: 14 }}>New Escalation</div>
            <form onSubmit={handleSubmit}>
              <div style={S.grid2}>
                <div>
                  <label style={S.label}>Vehicle Number *</label>
                  <FleetVehicleSelect
                    name="vehicle"
                    value={form.vehicle}
                    onChange={(e) => setForm({ ...form, vehicle: e.target.value })}
                    style={S.input}
                    required
                  />
                </div>
                <div>
                  <label style={S.label}>Date</label>
                  <input style={S.input} type="date" value={form.date}
                    onChange={e => setForm({ ...form, date: e.target.value })} />
                </div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Description *</label>
                <textarea style={S.textarea} placeholder="Describe the issue..."
                  value={form.desc} onChange={e => setForm({ ...form, desc: e.target.value })} required />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={S.label}>Tags (select all that apply)</label>
                <div style={S.tagWrap}>
                  {TAG_OPTIONS.map(t => (
                    <span key={t} style={{ ...S.tag, ...(form.tags.includes(t) ? S.tagOn : {}) }} onClick={() => toggleTag(t)}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button style={S.btnYellow} type="submit">🚨 Submit Escalation</button>
                <button style={S.btnBlack} type="button" onClick={() => setShowForm(false)}>Cancel</button>
              </div>
            </form>
            {formOk  && <div style={S.success}>✅ Escalation submitted!</div>}
            {formErr && <div style={S.errBox}>{formErr}</div>}
          </div>
        )}

        {/* Escalations List */}
        {loading ? (
          <p>Loading escalations...</p>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", color: "#888", padding: 40, fontSize: 14 }}>
            No escalations found
          </div>
        ) : filtered.map(e => (
          <div key={e._id || e.id} style={{ ...S.card, ...(e.status === "resolved" ? S.cardResolved : S.cardOpen) }}>
            {/* Header row */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 8 }}>
              <span style={{ fontFamily: "monospace", fontWeight: "bold", color: "#1565c0", fontSize: 14 }}>
                {e.vehicle}
              </span>
              <span style={{ fontSize: 12, color: "#888" }}>{e.date}</span>
              {(e.tags || []).map(t => (
                <span key={t} style={{ fontSize: 11, background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", color: "#c0392b", padding: "2px 8px", borderRadius: 12 }}>{t}</span>
              ))}
              <span style={{
                marginLeft: "auto", fontSize: 11, padding: "3px 12px", borderRadius: 12, fontWeight: "bold",
                background: e.status === "resolved" ? "#e6f9ee" : "#fde8e8",
                color:      e.status === "resolved" ? "#27ae60" : "#c0392b",
                border:     e.status === "resolved" ? "1px solid #27ae60" : "1px solid #c0392b",
              }}>
                {e.status === "resolved" ? "🟢 Resolved" : "🔴 Open"}
              </span>
            </div>

            {/* Description */}
            <p style={{ fontSize: 13, color: "#333", margin: "0 0 10px", lineHeight: 1.6 }}>{e.desc || e.description}</p>

            {/* Actions */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {e.status === "open" ? (
                <button style={S.btnSmall("green")} onClick={() => updateStatus(e._id || e.id, "resolved")}>
                  ✓ Mark Resolved
                </button>
              ) : (
                <button style={S.btnSmall("red")} onClick={() => updateStatus(e._id || e.id, "open")}>
                  ↩ Reopen
                </button>
              )}
              <button style={S.btnSmall("grey")} onClick={() => deleteEsc(e._id || e.id)}>
                🗑 Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
